import { Skeleton as ChakraSekeleton, Flex } from "@chakra-ui/react";

interface PropTypes {
    height?: number;
    width?: number;
    amount?: number;
}

const Skeleton = ({ height = 60, width = 80, amount = 4 }: PropTypes) => {
    return (
        <Flex
            w="full"
            direction="column"
            gap={6}
            borderRadius={10}
            data-testid="loading-skeleton"
        >
            <ChakraSekeleton h={10} w="50%" m="auto" />
            <Flex w="full" gap={3} justify="space-between">
                {[...Array(amount).keys()].map(k => (
                    <ChakraSekeleton
                        key={k}
                        h={height}
                        w={width}
                        borderRadius={10}
                        data-testid={`skeleton-${k}`}
                    />
                ))}
            </Flex>
        </Flex>
    );
};

export default Skeleton;
